import { Col, Row, Tabs, } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import Register from "./Pages/Register/Register";
import Logo from "assets/Images/Header/FullLogo.svg";
import Login from "./Pages/Login/Login";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const AccountIndex = (props: any) => {

  const [searchParams, setSearchParams] = useSearchParams();
  const [activeKey, setActiveKey] = useState("giris-yap");
  const navigate = useNavigate()

  const handleChangeTab = (key: string) => {
    if (key === "kurumsal-kayit-ol") {
     
      navigate("/kurumsal/kayit");
      props.onFinish(); 
      return; 
    }
    
    setSearchParams({ sayfa: key }); 
    setActiveKey(key);
  };
  

  useEffect(() => {
    const pageType = searchParams.get("sayfa")
    if(pageType==="giris-yap")
    {
      setActiveKey("giris-yap")
    }
    else if(pageType==="kayit-ol")
      {
        setActiveKey("kayit-ol")
      }
   
  }, [searchParams]);

  return (
    <Col span={24}>
      <Row gutter={[0, 20]} className="!mt-4">
   
        <Col span={24} className="!flex justify-center">
          <LazyLoadImage
            wrapperWidth="200px"
            wrapperHeight="38px"
            style={{ objectFit: "contain" }}
            src={Logo}
            alt="Sarı ilanlar logosu"
          />
        </Col>
        <Col span={24}>
          <Tabs activeKey={activeKey} onChange={handleChangeTab}>
            <TabPane tab="Giriş Yap" key="giris-yap">
              <Login onFinish={props.onFinish} />
            </TabPane>
            <TabPane tab="Kayıt Ol" key="kayit-ol">
              <Register onFinish={props.onFinish} />
            </TabPane>
            
            <TabPane tab="Kurumsal Üyelik Oluştur" key="kurumsal-kayit-ol">
              
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </Col>
  );
};

export default AccountIndex;
